import React from 'react';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';
import { Icon } from 'iovisit-theme/components';

import { toPublicURL } from '@plone/volto/helpers';

const messages = defineMessages({
  share_on: {
    id: 'share_on',
    defaultMessage: 'Condividi su',
  },
  share_on_common: {
    id: 'share_on_common',
    defaultMessage: 'Condividi sui social',
  },
  shareButton: {
    id: 'shareButton',
    defaultMessage: 'Condividi questa pagina',
  },
});

const Sharing = ({ url, title, showLabel }) => {
  const intl = useIntl();
  const publicUrl = toPublicURL(url);

  let socials = [
    {
      key: 'facebook',
      value: 'facebook',
      text: 'Facebook',
      url: `https://www.facebook.com/sharer/sharer.php?u=${publicUrl}`,
      icon: 'facebook-f',
    },
    {
      key: 'twitter',
      value: 'twitter',
      text: 'Twitter',
      url: `https://twitter.com/intent/tweet?url=${publicUrl}`,
      icon: 'twitter',
    },
    {
      key: 'linkedin',
      value: 'linkedin',
      text: 'LinkedIn',
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${publicUrl}&title=${publicUrl}`,
      icon: 'linkedin',
    },
    {
      key: 'whatsapp',
      value: 'whatsapp',
      text: 'Whatsapp',
      url: `https://api.whatsapp.com/send?phone=&text=${publicUrl}`,
      icon: 'whatsapp',
    },
    {
      key: 'telegram',
      value: 'telegram',
      text: 'Telegram',
      url: `https://t.me/share/url?url=${publicUrl}&text=${title}`,
      icon: 'telegram',
    },
  ];

  const { buttonProps, itemProps, isOpen, setIsOpen } = useDropdownMenu(
    socials.length,
  );

  return (
    <div className="page-share">
      <div className="ui inline dropdown">
        <div
          {...buttonProps}
          aria-label={intl.formatMessage(messages.shareButton)}
        >
          <Icon prefix="fas" icon="share-alt" className="icon" />
          {showLabel && (
            <span className="icon-label">
              {intl.formatMessage(messages.share_on_common)}
            </span>
          )}
        </div>

        <div className={cx('menu', { visible: isOpen })} role="menu">
          {socials.map((item, i) => (
            <a
              {...itemProps[i]}
              className="item"
              href={item.url}
              key={i}
              target="_blank"
              rel="noopener noreferrer"
              title={`${intl.formatMessage(messages.share_on)} ${item.text}`}
            >
              <Icon prefix="fab" icon={item.icon} className="icon" />
              {item.text}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Sharing;
